<template>
    <article class="term-modal">
        <div
            class="term-modal__overlay"
            @click="$emit('hideModal')"></div>
        <div class="term-modal__content">
            <button
                class="term-modal__close"
                @click.prevent="$emit('hideModal')"></button>
            <div
                class="term-modal__wrapper"
                v-html="content.props.text"></div>
        </div>
    </article>
</template>

<script>
    export default {
        name: 'TermModal',
        props: {
            content: {
                type: Object,
                default: () => {}
            }
        },
    }
</script>